module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAABACAMAAACnZz6fAAAAAXNSR0IB2cksfwAAAE5QTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxKKmWQAAABp0Uk5TAAgvT1+AYD8gd1g4MBhAb0hwKBB4UCdXZ2g3X6A6AAAAwElEQVR4nO3T3RKCIBAFYCyOoqBY9mPv/6Ix4iC70DhN001xLuVjgN1VCJrqcJSgqZlokIYa1QKdVvQbNcbt6dnZzDgycMFMD5iUUGMxZggxBqccIcbivGcmXLIkNhpXtnhr7tJl3szA3j3JtM4du47bPiifUNYapAVjcnRqLKpdA6TkcyN9Wm5kyChCGZiJ59At+pCHqBC9mMztYv33Zi05+UO3TsyL2e/FWvIHN1s3Xs3qd2asmGKK+THD8qZ5AqYzDTONORtgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/compose-alert--channels--facebook.png
// module id = 761
// module chunks = 0